// Configuración centralizada de la API con fallback inteligente
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getApiUrl = () => {
  // 1. Si la variable de entorno está definida y es válida, la usamos
  if (BACKEND_URL && BACKEND_URL !== "undefined" && BACKEND_URL !== "") {
    return BACKEND_URL.endsWith('/') ? `${BACKEND_URL}api` : `${BACKEND_URL}/api`;
  }

  // 2. Fallback: Si estamos en el navegador, intentamos detectar el backend en el mismo host pero puerto 8000
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    
    // Si accedemos por IP o localhost, es muy probable que el backend esté en el 8000
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
      return `${protocol}//${hostname}:8000/api`;
    }
    
    // Si estamos en el dominio de producción pero sin variable de entorno, 
    // asumimos que el backend está en la misma URL bajo /api (vía proxy de nginx)
    return `${protocol}//${hostname}/api`;
  }

  // 3. Fallback final para SSR o casos extraños
  return "/api";
};

export const API = getApiUrl();
console.log("API URL inicializada en:", API);
